<template>
  <div id="shop" class="shop-container">
    <PublicModule title="新闻资讯">
      <a-row type="flex" justify="start" align="middle" class="shop-wrapper">
        <a-col v-for="(item, index) in shopList" :key="index" :span="12">
          <div class="shop-content">
            <div class="shop-body">
              <div class="shop-detail">
                <div class="shop-info">
                  <p class="shop-title">{{ item.name }}</p>
                  <p class="shop-instroduce">{{ item.remark }}</p>
                </div>
                <div class="shop-logo">
                  <img :src="item.logo" alt="">
                </div>
              </div>
              <a-row :gutter="21" class="shop-buttons">
                <a-col :span="8" class="shop-button-item">
                  <div class="shop-button-other" @click.prevent="handleClick(item)">
                    {{ item.other.label }}
                    <img src="../../assets/image/goto.png" alt="">
                  </div>
                </a-col>
              </a-row>
            </div>
          </div>
        </a-col>
      </a-row>
    </PublicModule>
  </div>
</template>

<script>
import PublicModule from '@/components/PublicModule.vue'

export default {
  name: 'HomeView',
  components: {
    PublicModule
  },
  data() {
    return {
      shopList: [
        {
          remark: '「你的城市，我的远方」---南宁',
          logo: require('../../assets/image/case2.png'),
          other: { label: 'MORE', href: 'https://mp.weixin.qq.com/s/rTrHzJLsUvMJ3vZWkmOrXQ' }
        },
        {
          remark: '「你的城市，我的远方」---兰州',
          logo: require('../../assets/image/case9.png'),
          other: { label: 'MORE', href: 'https://mp.weixin.qq.com/s/bAu3SnVzOjz3j4slj-rsoA' }
        },
        {
          remark: '万万没想到！郑州绿城通还能这样充值！太方便',
          logo: require('../../assets/image/cp3.png'),
          other: { label: 'MORE', href: 'https://mp.weixin.qq.com/s/jC6akDe3WkoREkt27k0XMg' }
        },
        {
          name: '强！势！官！宣！',
          remark: '4月28日n中国城市人才吸引力排名100强。\n 公布南京排名全国第六,厉害了我的大蓝鲸!\n而位居榜单前三名分别是上海、深圳、北京。南京和广州、杭州、成都济南、苏州、天津一同进入前十!',
          logo: require('../../assets/image/cp4.png'),
          other: { label: 'MORE', href: 'https://mp.weixin.qq.com/s/9B0YrjPgVHn16icJJ-YLPw' }
        }
      ]
    }
  },
  methods: {
    handleClick(val) {
      window.open(val.other.href)
    }
  }
}
</script>

<style lang="scss" scoped>
.shop-container {
  width: 100%;
  padding: 0 120px;
  box-sizing: border-box;

  .shop-wrapper {
    padding-top: 50px;

    .shop-content {
      width: 100%;
      padding: 20px 10px;
      box-sizing: border-box;

      .shop-body {
        width: 100%;
        height: 365px;
        padding: 40px;
        background: rgba(244, 246, 249, 0.7);
        border: 1.33px solid rgba(172, 172, 172, 0.19);
        color: #2d2d2d;
        font-family: PingFangSC, PingFangSC-Medium;
        box-shadow: 0px 11px 17px 0px rgba(22, 84, 195, 0.16);

        .shop-detail {
          display: flex;
          height: 52.6%;
          text-align: left;

          .shop-info {
            width: 62.5%;

            .shop-title {
              margin-bottom: 20px;
              font-size: 32px;
              font-weight: 500;
              line-height: 45px;
              color: red;
            }

            .shop-instroduce {
              font-size: 18px;
              font-weight: 400;
              line-height: 25px;
            }
          }

          .shop-logo {
            text-align: center;
            flex: 1 1;
            overflow: hidden;

            img {
              max-height: 100%;
            }
          }
        }

        .shop-buttons {
          margin-top: 100px;

          .shop-button-item {
            box-sizing: border-box;
            margin-bottom: 26px;

            .shop-button-link {
              width: 214px;
              height: 54px;
              display: block;
              background: #ffffff;
              white-space: nowrap;
              border-radius: 6px;
              box-shadow: 0px 3px 5px 0px rgba(192, 192, 192, 0.62);
              backdrop-filter: blur(14.67px);
              font-size: 18px;
              line-height: 53px;
              font-weight: 400;

              &:hover {
                background: #ecf2fe;
                color: #0c27af;
                border: 1.47px solid #0c27af;
                backdrop-filter: blur(14.67px);
              }
            }

            .shop-button-other {
              display: block;
              font-size: 18px;
              font-weight: 400;
              line-height: 53px;
              text-align: left;
              color: #0c27af;

              img {
                width: 8px;
                height: 15px;
                margin-left: 6px;
                vertical-align: initial;
              }
            }
          }
        }

        &:hover {
          .shop-title {
            color: #0C27AF;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
@media (max-width: 768px) {
  .shop-container {
    padding: 12px !important;
  }

  .shop-wrapper {
    padding-top: 24px !important;
  }

  .shop-wrapper .ant-col-12 {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .shop-body {
    height: auto !important;
    padding: 16px !important;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.06);
  }

  .shop-detail {
    flex-direction: column !important;
    height: auto !important;
  }

  .shop-info {
    width: 100% !important;
  }

  .shop-logo {
    width: 100% !important;
    text-align: center;
    margin-top: 12px;
  }

  .shop-logo img {
    max-width: 100%;
    height: auto;
    border-radius: 12px;
  }

  .shop-title {
    font-size: 20px !important;
    color: #2d2d2d !important;
  }

  .shop-instroduce {
    font-size: 14px !important;
  }

  .shop-buttons {
    margin-top: 16px !important;
  }

  .shop-button-link,
  .shop-button-other {
    line-height: 40px !important;
    font-size: 16px !important;
  }

  a-col[span] {
    width: 100% !important;
  }
}
</style>
